import {
  provideSoftAppsModule,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { default as en } from '../i18n/en.json';
import { default as de } from '../i18n/de.json';
import { SOFTLINE_PERMISSION_ABC_ANALYSIS } from './abc-analysis.shared';
import { abcAnalysisRoutes } from './abc-analysis.routes';
import { provideABCAnalysisGlobals } from './abc-analysis.globals';

export function provideABCAnalysisProviders() {
  return [
    ...provideSoftAppsModule(
    {
      name: 'abc-analysis',
      title: '#ABC_ANALYSIS.APP_TITLE',
      icon: 'fa-regular fa-chart-pie',
      route: '/abc-analysis/',
      permission: SOFTLINE_PERMISSION_ABC_ANALYSIS,
      group: getModuleGroupByName('Lager'),
    },
    withSoftAppsModuleTranslation({ de, en }),
    withSoftAppsModuleRoutes({
      app: abcAnalysisRoutes,
    })),
    ...provideABCAnalysisGlobals(),
  ];
}
